import { jsx, jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_2690_2964)", children: /* @__PURE__ */ jsx("path", { d: "M16 1H2V17H4V3H16V1ZM21 5H6V23H21V5ZM19 21H8V7H19V21Z", fill: "black" }) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2690_2964", children: /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "white" }) }) })
] });
export default SvgCopy;
